import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, Table, TableRow, Checkbox, Tooltip, TableBody} from '@mui/material';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';
import { Button, Dialog } from '@totalsoft/rocket-ui';
import { BoldTableHead, BoxActionsWrapper, DenseTableCell } from 'components/common/CommonStyles';
import Close from '@mui/icons-material/Close';
import { IconButton } from '@totalsoft/rocket-ui';
import Search from '@mui/icons-material/Search';
import { SearchField, SearchGrid, TableGrid, AddServicesHeaderTableCell} from '../style/OfferFinancialServicesAddServicesStyle';

const OfferFinancialServicesAddServicesComponent = ({
  showModal,
  t,
  onCloseModal,
  serviceTypesList,
  serviceLinkingList,
  onServiceTypeSelected,
  addServices,
  onSelectAllServiceTypesChange,
  onSearchChange,
  search,
  onResetFilters,
  serviceAreSelected
}) => {
  const getExcluledServiceName = service => {
    var sourceService = serviceLinkingList.filter(x => x.sourceServiceTypeId === service.serviceTypeId && x.linkingTypeId === 2);
    var destService = serviceLinkingList.filter(x => x.destServiceTypeId === service.serviceTypeId && x.linkingTypeId === 2);
    var linkedServiceName = null;
    if (sourceService.length > 0) linkedServiceName = sourceService[0].destServiceName;
    if (destService.length > 0) linkedServiceName = destService[0].sourceServiceName;

    return linkedServiceName;
  };

  return (
    <Dialog
      open={showModal}
      onClose={onCloseModal}
      aria-labelledby='availableUploadDocuments-dialog-title'
      maxWidth='xl'
      title={
      <Grid container item xs={12} >
        <Grid>{t('OfferEdit.FinancialServices.Title')}</Grid>
         <SearchGrid item xs={12} >
            <SearchField
              id={'offerEdit_FinancialServices_extendedFieldsFilters_fullText'}
              name='search'
              fullWidth={true}
              value={search}
              onChange={onSearchChange}
              label={t('OfferEdit.FinancialServices.ServiceName')}
              startAdornment={<Search />}
              endAdornment={
                <IconButton
                  onClick={onResetFilters}
                  color='primary'
                  variant='text'
                  size='tiny'
                  tooltip={t('Tooltips.ResetFilters')}
                  id={'offerEditFinancialServices_filters_resetBtn'}
                >
                  <Close />
                </IconButton>
              }
            />
          </SearchGrid>
          <Grid container item xs={12}>
          <Table>
            <BoldTableHead >
              <TableRow >
                <AddServicesHeaderTableCell width={'7%'}>
                  <Tooltip title={t('OfferEdit.FinancialServices.CheckAllServices')}>
                    <Checkbox
                    onChange={onSelectAllServiceTypesChange}
                    checked={serviceAreSelected}
                     />
                  </Tooltip>
                </AddServicesHeaderTableCell>
                <AddServicesHeaderTableCell>{t('OfferEdit.FinancialServices.ServiceName')}</AddServicesHeaderTableCell>
                <AddServicesHeaderTableCell width={'50%'}>{t('OfferEdit.FinancialServices.Message')}</AddServicesHeaderTableCell>
              </TableRow>
            </BoldTableHead>
            </Table>
            </Grid>
        </ Grid>}
      content={
        <Grid container item xs={12} >
          <TableGrid  item xs={12}>
          <Table >
            <TableBody >
              {serviceTypesList.map((service) => {
                var linkedServiceName = getExcluledServiceName(service);
                return (
                  <TableRow key={service.serviceTypeId}>
                    <DenseTableCell width={'7%'}>
                      <Checkbox
                        checked={service.selected || false}
                        onChange={onCheckBoxChange(onServiceTypeSelected(service))}
                        value='1'
                        disabled={linkedServiceName}
                      />
                    </DenseTableCell>
                    <DenseTableCell>{service.serviceName}</DenseTableCell>
                    <DenseTableCell width='50%'>
                      {linkedServiceName ? t('OfferEdit.FinancialServices.Warning', { linkedServiceName }) : ''}
                    </DenseTableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          </TableGrid>
        </Grid>
      }
      actions={
        <BoxActionsWrapper forDialog>
          <Button onClick={addServices} color='primary' variant='contained'>
            {t('Add')}
          </Button>
          <Button onClick={onCloseModal} color='primary' variant='outlined'>
            {t('Close')}
          </Button>
        </BoxActionsWrapper>
      }
    />
  );
};

OfferFinancialServicesAddServicesComponent.propTypes = {
  showModal: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  serviceTypesList: PropTypes.array.isRequired,
  serviceLinkingList: PropTypes.array.isRequired,
  availableUploadDocuments: PropTypes.array,
  onCloseModal: PropTypes.func.isRequired,
  addServices: PropTypes.func.isRequired,
  onServiceTypeSelected: PropTypes.func.isRequired,
  onSelectAllServiceTypesChange: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  search: PropTypes.string,
  onResetFilters: PropTypes.func.isRequired,
  serviceAreSelected: PropTypes.bool.isRequired
};

export default withTranslation()(OfferFinancialServicesAddServicesComponent);
